/**
 * Traffic Light Color System
 *
 * ALL status indicators use ONLY three semantic colors:
 *   Green  (#16A34A / bg-green-600) — good, done, resolved, approved
 *   Amber  (#D97706 / bg-amber-500) — in progress, waiting, pending, needs attention
 *   Red    (#DC2626 / bg-red-600)   — action required, blocked, overdue, rejected
 *   Slate  (#64748B / bg-slate-500) — neutral, expired, revoked, cancelled
 *
 * NO other colors (cyan, fuchsia, teal, violet, purple, indigo, blue) in status dots.
 * The dot carries semantic color. The pill text is always monochrome.
 */
// Severity uses the same traffic light: critical/high=red, medium=amber, low=green
export const SEVERITY_COLORS = {
    critical: '#DC2626',
    high: '#DC2626',
    medium: '#D97706',
    low: '#16A34A',
};
// Hex colors for StatusBadge inline style dots
export const STATUS_COLORS = {
    // Green — done, approved, resolved, satisfied
    approved: '#16A34A',
    resolved: '#16A34A',
    completed: '#16A34A',
    satisfied: '#16A34A',
    closed: '#16A34A',
    // Amber — in progress, waiting, pending
    pending: '#D97706',
    waiting: '#D97706',
    reviewing: '#D97706',
    in_review: '#D97706',
    scheduled: '#D97706',
    evidence_submitted: '#D97706',
    active: '#D97706',
    // Red — action required, blocked, overdue
    action_req: '#DC2626',
    open: '#DC2626',
    overdue: '#DC2626',
    cancelled: '#DC2626',
    rejected: '#DC2626',
    // Neutral
    expired: '#64748B',
    revoked: '#64748B',
    excepted: '#64748B',
    waived: '#64748B',
};
// Tailwind bg classes for severity pill dots
export const SEVERITY_BG_CLASSES = {
    critical: 'bg-red-600',
    high: 'bg-red-600',
    medium: 'bg-amber-500',
    low: 'bg-green-600',
};
// Tailwind bg classes for status filter pill dots
export const STATUS_BG_CLASSES = {
    // Green
    approved: 'bg-green-600',
    resolved: 'bg-green-600',
    completed: 'bg-green-600',
    satisfied: 'bg-green-600',
    closed: 'bg-green-600',
    // Amber
    pending: 'bg-amber-500',
    waiting: 'bg-amber-500',
    reviewing: 'bg-amber-500',
    in_review: 'bg-amber-500',
    scheduled: 'bg-amber-500',
    evidence_submitted: 'bg-amber-500',
    active: 'bg-amber-500',
    // Red
    action_req: 'bg-red-600',
    open: 'bg-red-600',
    overdue: 'bg-red-600',
    cancelled: 'bg-red-600',
    rejected: 'bg-red-600',
    // Neutral
    expired: 'bg-slate-500',
    revoked: 'bg-slate-500',
    excepted: 'bg-slate-500',
    waived: 'bg-slate-500',
};
/**
 * Traffic light dot colors for HeroDetail pills.
 * ONLY green/amber/red/slate — no blue, purple, indigo, or other colors.
 */
export const STATUS_DOT_COLORS = {
    // Green — done, approved, resolved
    approved: 'bg-green-500',
    closed: 'bg-green-500',
    complete: 'bg-green-500',
    resolved: 'bg-green-500',
    satisfied: 'bg-green-500',
    // Amber — in progress, waiting
    waiting: 'bg-amber-500',
    reviewing: 'bg-amber-500',
    pending: 'bg-amber-500',
    scheduled: 'bg-amber-500',
    evidence_submitted: 'bg-amber-500',
    exception_granted: 'bg-amber-500',
    // Red — action required, blocked
    action_req: 'bg-red-500',
    open: 'bg-red-500',
    rejected: 'bg-red-500',
    overdue: 'bg-red-500',
    // Neutral
    cancelled: 'bg-slate-400',
    expired: 'bg-slate-400',
};
export const STATUS_LABELS = {
    // Policy statuses
    approved: 'APPROVED',
    waiting: 'WAITING',
    reviewing: 'REVIEWING',
    action_req: 'ACTION REQ',
    // Building statuses
    pending: 'PENDING REVIEW',
    rejected: 'REJECTED',
    // Finding statuses
    open: 'ACTION REQ',
    closed: 'APPROVED',
    exception_granted: 'EXCEPTION GRANTED',
    evidence_submitted: 'EVIDENCE SUBMITTED',
    // Inspection statuses
    scheduled: 'SCHEDULED',
    complete: 'COMPLETE',
    cancelled: 'CANCELLED',
};
//# sourceMappingURL=colors.js.map